/* Hlavicka vygruntujeme.cz - lupa, vyskakovaci vyhledavani a znacka V
   (2026-08-08)

   Nazev souboru je historicky (puvodne jen mobil), obsluhuje ale i
   desktopovou sticky listu. Prejmenovani by znamenalo sahat do
   snippets/vg-custom.liquid, coz za to nestoji.

   Rozlozeni resi assets/vg-header-mobile.css. Tady je jen to, co v CSS
   nejde:

   1. Tlacitko lupy - motiv ho nema, hlavicka umi jen viditelne pole
      pres celou sirku. Dopisuje se do kazdeho .header__top (tedy i do
      klonu ve sticky liste).
   2. Presun puvodniho vyhledavaciho formulare do okna uprostred
      obrazovky. Formular se PRESOUVA, neklonuje - naseptavac motivu ma
      na nem navesene posluchace a ty presun prezijou, kdezto klon by
      byl mrtvy.
   3. Dopocet vysky okna podle visualViewport, aby ho na telefonu
      neprekryla vyvolana klavesnice (100vh o klavesnici nevi).
   4. Ctvercova znacka V do sticky listy na desktopu. Sticky lista je
      klon .header__bottom a logo v ni motiv vubec nevykresluje - pri
      odrolovani tak zmizela znacka obchodu. Na mobilu resi totez CSS
      primo na klonu .header__top.

   Posluchace jsou delegovane na dokumentu - jeden pro celou stranku,
   ne jeden na kazde tlacitko. */
(function () {
  'use strict';

  var MODAL_ID = 'vg-search-modal';

  var ICON_SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.6-3.6"></path></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';

  var modal = null;

  /* --- Okno s vyhledavanim ------------------------------------------- */
  function buildModal() {
    if (modal) return modal;

    var form = document.querySelector('main-header .mobile-search search-form');
    if (!form) return null;

    modal = document.createElement('div');
    modal.className = 'vg-search-modal';
    modal.id = MODAL_ID;
    modal.hidden = true;
    modal.innerHTML =
      '<div class="vg-search-modal__backdrop" data-vg-search-close></div>' +
      '<div class="vg-search-modal__box mobile-search" role="dialog" aria-modal="true" aria-label="Vyhledávání">' +
        '<button type="button" class="vg-search-modal__close" data-vg-search-close aria-label="Zavřít vyhledávání">' + ICON_CLOSE + '</button>' +
        '<p class="vg-search-modal__title">Co hledáte?</p>' +
      '</div>';

    document.body.appendChild(modal);
    modal.querySelector('.vg-search-modal__box').appendChild(form);
    return modal;
  }

  function setExpanded(state) {
    var btns = document.querySelectorAll('.vg-search-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-expanded', state ? 'true' : 'false');
    }
  }

  /* Klavesnice na telefonu prekryje spodni cast obrazovky, ale 100vh o
     tom nevi a okno by pod ni zmizelo. visualViewport zna skutecnou
     viditelnou plochu, takze se okno drzi v jejim stredu. */
  function fit() {
    if (!modal || modal.hidden) return;
    var vv = window.visualViewport;
    if (!vv) return;
    modal.style.height = vv.height + 'px';
    modal.style.top = vv.offsetTop + 'px';
  }

  function openSearch() {
    var m = buildModal();
    if (!m) return;

    m.hidden = false;
    document.documentElement.classList.add('vg-search-open');
    setExpanded(true);
    fit();

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fit);
      window.visualViewport.addEventListener('scroll', fit);
    }

    var input = m.querySelector('input[name="q"]');
    if (input) {
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }
  }

  function closeSearch() {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    modal.style.height = '';
    modal.style.top = '';
    document.documentElement.classList.remove('vg-search-open');
    setExpanded(false);

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', fit);
      window.visualViewport.removeEventListener('scroll', fit);
    }
  }

  /* --- Tlacitko lupy v hlavicce -------------------------------------- */
  function ensureButtons() {
    var tops = document.querySelectorAll('.header__top');
    for (var i = 0; i < tops.length; i++) {
      if (tops[i].querySelector('.vg-search-btn')) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vg-search-btn';
      b.setAttribute('aria-label', 'Hledat');
      b.setAttribute('aria-controls', MODAL_ID);
      b.setAttribute('aria-expanded', 'false');
      b.innerHTML = ICON_SEARCH;
      /* Poradi na radku urcuje CSS pres order, staci pripojit na konec. */
      tops[i].appendChild(b);
    }
  }

  /* --- Znacka V ve sticky liste (desktop) ---------------------------- */
  function ensureMark() {
    var bars = document.querySelectorAll('.sticky-header .header__bottom');
    for (var i = 0; i < bars.length; i++) {
      if (bars[i].querySelector('.vg-mark')) continue;
      var a = document.createElement('a');
      a.className = 'vg-mark';
      a.href = '/';
      a.setAttribute('aria-label', 'Vygruntujeme.cz – úvodní stránka');
      a.textContent = 'V';
      /* Prvni v poradi, aby stala vlevo pred polozkami menu. */
      bars[i].insertBefore(a, bars[i].firstChild);
    }
  }

  /* --- Udalosti ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.vg-search-btn')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-vg-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) closeSearch();
  });

  var queued = false;
  function vgRun() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      buildModal();
      ensureButtons();
      ensureMark();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vgRun);
  } else {
    vgRun();
  }

  /* Sticky lista vznika az po nacteni jako klon hlavicky - tlacitko i
     znacka se do ni musi doplnit dodatecne. */
  new MutationObserver(vgRun).observe(document.documentElement, { childList: true, subtree: true });
})();
